import { useMemo } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { getDocCollection } from "../util/docs";
const useMdxQuery = () => (useStaticQuery(graphql `
            ## Ignore me, typegen
            query {
                allMdx(
                    filter: {
                        askAvaPath: { ne: null }
                    }
                    sort: {
                        fields: [fileAbsolutePath],
                        order: [ASC]
                    }
                ) {
                    nodes {
                        id
                        askAvaPath
                        askAva {
                            slug
                            prefix
                            version
                        }
                        frontmatter {
                            category
                            subCategory
                            title
                            group
                            type
                            name
                        }
                    }
                }

                site {
                    siteMetadata {
                        avaDocsBase
                    }
                }
            }
        `));
export const useDocCollection = () => {
    const data = useMdxQuery();
    const { base, docs, catIndex, orderedCategories, } = useMemo(() => getDocCollection(data), [data]);
    return {
        categories: orderedCategories,
        catIndex,
        docs,
        base,
    };
};
